import Gallery from 'react-scale/components/elements/gallery';
import Countdown from 'react-scale/components/pages/rapid/countdown';

const GalleryCountdown = () => (
  <Gallery tabItems={tabItems} batch duration={5000} gradientColor={[0, 0, 0]} />
);

const tabItems = [
  {
    label: 'Upload Data',
    text: 'Upload data from CSV, text file, Amazon S3, GCP Cloud Storage, or the Scale API',
    img: {
      src: '/static/images/pages/rapid/tab/1-upload.png',
      alt: 'upload'
    }
  },
  {
    label: 'Instructions',
    text: 'Provide examples and instructions as well as possible labels and choose multi-select or single-select',
    img: {
      src: '/static/images/pages/rapid/tab/2-instructions.png',
      alt: 'instructions'
    }
  },
  {
    label: 'Feedback',
    text: 'Receive feedback on labeler instructions',
    img: {
      src: '/static/images/pages/rapid/tab/3-feedback.png',
      alt: 'feedback'
    }
  },
  {
    label: 'Labeled Data',
    text: 'Receive labeled calibration data back within a matter of hours',
    node: <Countdown />,
    img: {
      src: '/static/images/pages/rapid/tab/4-labeled-data.png',
      alt: 'labeled-data'
    }
  },
  {
    label: 'Larger Volumes',
    text: 'Scale to larger volumes with dynamic task allocation to ensure quality and speed',
    img: {
      src: '/static/images/pages/rapid/tab/5-large-volumes.png',
      alt: 'large-volumes'
    }
  },
  {
    label: 'Scale to 3000 tasks',
    text: 'Scale to 3000 tasks with a typical return time of 3 days',
    img: {
      src: '/static/images/pages/rapid/tab/6-scale-up-to.png',
      alt: 'scale-up-to'
    }
  }
];

export default GalleryCountdown;
